import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'
import { MerchantData } from './insertMerchant'

const getMerchantRequestBody = (mid: string) => {
  return {
    mid,
    configDetails: [
      {
        configType: 'PAYMENT_ACCEPTANCE',
        configValues: [
          {
            status: 'ACTIVE',
            key: '560',
            value: 'Y',
          },
          {
            status: 'ACTIVE',
            key: '580',
            value: 'Y',
          },
        ],
      },
      {
        configType: 'ALLOWED_RETRIES',
        configValues: [
          {
            status: 'ACTIVE',
            key: 'RETRY_COUNT',
            value: '4',
          },
        ],
      },
      {
        configType: 'TIMEOUT',
        configValues: [
          {
            status: 'ACTIVE',
            key: 'CLOSE_TIME',
            value: '2000',
          },
        ],
      },
    ],
  }
}

const addMerchantConfig = (merchantData: MerchantData, tokens: any) => {
  let requestBody
  if (!!merchantData.config) {
    let configJson
    try {
      configJson = JSON.parse(merchantData.config)
    } catch (e) {
      throw {
        data: {
          error: {
            code: '400',
            message: 'Invalid JSON',
          },
        },
      }
    }
    requestBody = {
      mid: merchantData.mid,
      configDetails: configJson,
    }
  } else {
    requestBody = getMerchantRequestBody(merchantData.mid)
  }
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.addMerchantConfig,
    body: requestBody,
    method: 'POST',
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.status === 'SUCCESS') {
      return data?.data
    } else {
      throw data
    }
  })
}

export { addMerchantConfig }
